var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_268_1066)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_268_1066",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.134 3.08357C25.4832 2.35347 25.1761 1.47247 24.42 1.18382C21.7683 0.171462 18.9077 -0.201949 16.072 0.103556C12.7493 0.461517 9.59185 1.73742 6.95329 3.78838C4.31474 5.83933 2.29924 8.58434 1.13254 11.716C-0.0341615 14.8476 -0.306002 18.2422 0.347463 21.5197C1.00093 24.7971 2.5539 27.8278 4.83244 30.2725C7.11099 32.7173 10.0251 34.4794 13.2485 35.3615C16.4719 36.2437 19.8772 36.2111 23.0831 35.2674C25.8192 34.4619 28.3178 33.02 30.3785 31.0681C30.966 30.5115 30.9118 29.5801 30.3093 29.0397C29.7068 28.4994 28.7848 28.5558 28.1885 29.103C26.4976 30.6547 24.4694 31.8042 22.2555 32.4559C19.5716 33.246 16.7207 33.2733 14.0221 32.5348C11.3236 31.7962 8.88393 30.321 6.97637 28.2743C5.06882 26.2277 3.7687 23.6904 3.22163 20.9466C2.67456 18.2028 2.90214 15.3609 3.87888 12.7391C4.85562 10.1174 6.54296 7.81932 8.75191 6.1023C10.9609 4.38528 13.6042 3.31712 16.3859 3.01744C18.6805 2.77024 20.9944 3.05399 23.1511 3.83848C23.9117 4.11513 24.7848 3.81367 25.134 3.08357Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.134 3.08357C25.4832 2.35347 25.1761 1.47247 24.42 1.18382C21.7683 0.171462 18.9077 -0.201949 16.072 0.103556C12.7493 0.461517 9.59185 1.73742 6.95329 3.78838C4.31474 5.83933 2.29924 8.58434 1.13254 11.716C-0.0341615 14.8476 -0.306002 18.2422 0.347463 21.5197C1.00093 24.7971 2.5539 27.8278 4.83244 30.2725C7.11099 32.7173 10.0251 34.4794 13.2485 35.3615C16.4719 36.2437 19.8772 36.2111 23.0831 35.2674C25.8192 34.4619 28.3178 33.02 30.3785 31.0681C30.966 30.5115 30.9118 29.5801 30.3093 29.0397C29.7068 28.4994 28.7848 28.5558 28.1885 29.103C26.4976 30.6547 24.4694 31.8042 22.2555 32.4559C19.5716 33.246 16.7207 33.2733 14.0221 32.5348C11.3236 31.7962 8.88393 30.321 6.97637 28.2743C5.06882 26.2277 3.7687 23.6904 3.22163 20.9466C2.67456 18.2028 2.90214 15.3609 3.87888 12.7391C4.85562 10.1174 6.54296 7.81932 8.75191 6.1023C10.9609 4.38528 13.6042 3.31712 16.3859 3.01744C18.6805 2.77024 20.9944 3.05399 23.1511 3.83848C23.9117 4.11513 24.7848 3.81367 25.134 3.08357Z",
    stroke: "url(#paint0_linear_268_1066)",
    strokeWidth: 6,
    mask: "url(#path-1-inside-1_268_1066)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_268_1066",
    x1: 36,
    y1: -0.00000184591,
    x2: -6.84365,
    y2: 12.4508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93B4BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A677B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_1066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.a0dff32eea4ca9613eea21ae2eb71b41.svg";
export { ForwardRef as ReactComponent };